import React from 'react'
import './Loader.css'
const Loader = () => {
  return (
    <div className='loader__container'>
    <span className="loader"></span>
    </div>
  )
}

export default Loader